import createModule from "../createModule"
import { get, isEmpty } from "lodash"
import { Creators as DialogCreators } from "modules/dialog/model"
import view from "./view"
import { getModel, getSelectedDate, getInstrument, getAvailability, getModelAvailability } from "./selectors"
import { Creators } from "./model"
import { instrumentPortfolioQuery, instrumentSecurityQuery } from "./helpers"
import { getModels, MODELS_QUERY } from "resources/models"

export default createModule({
  view,
  externalProps: (state, props) => ({
    accountId: state.global.selected.accountId,
    account: state.global.selected.account,
    models: getModels(state),
    instrument: getInstrument(state, props),
    selectedDate: getSelectedDate(state, props),
    modelId: getModel(state, props),
    modelAvailability: getModelAvailability(state, props),
  }),
  required: ["account"],
  data: [{
    ...MODELS_QUERY,
    as: null,
  }, {
    resource: "modelsAvailability",
    as: null,
    url: () => ({
      id: "models",
      query: "query { models { id, name, availability { currentDate, factorsStartDate, securitiesStartDate } } }",
    }),
  }, {
    resource: "researchTopicInstrument",
    url: ({ modelId, instrument }) => {
      if (!modelId || isEmpty(instrument)) { return null }

      return ({
        id: `instrument-${modelId}-${JSON.stringify(instrument)}`,
        ...(instrument.type === "portfolio" ? instrumentPortfolioQuery(instrument) : instrumentSecurityQuery(modelId, instrument)),
      })
    },
  },
  {
    resource: "topicModeledDates",
    as: null,
    url: ({ modelId, modelAvailability }) => {
      if (!modelId) { return null }

      const { securitiesStartDate: earliestDate, currentDate: latestDate } = modelAvailability
      if (!latestDate || !earliestDate) { return null }

      return {
        id: `${modelId}${earliestDate}${latestDate}`,
        query: `query ($modelId: String!, $from: Date!, $to: Date!) {
          model (id: $modelId) {
            availability {
              dates(from: $from, to: $to)
            }
          }
        }`,
        variables: { modelId, from: earliestDate, to: latestDate },
      }
    },
  }, {
    resource: "instrumentPortfolioDates",
    url: ({ account, instrument }) => {
      if (!instrument || instrument.type !== "portfolio") { return null }
      return `/api/${account}/p/${instrument.id}`
    },
  }],
  mapStateToProps: (state, props) => ({
    step: get(state, "modules.researchTopicCreate.step"),
    creating: get(state, "modules.researchTopicCreate.creating"),
    availability: getAvailability(state, props),
  }),
  actions: {
    ...Creators,
    closeDialog: DialogCreators.close,
  },
})
